import React, { Fragment as F, Component } from 'react';
import uniqueId from 'react-html-id';
import $ from 'jquery';

//import styles from './RedactorTextarea.css';

export default class AceTextarea extends Component {
	constructor(props) {
		super();

		uniqueId.enableUniqueIds(this);
	}

	initEditor(options) {
		const { onChange, readOnly = false } = this.props;

		this.editor = ace.edit(options.ace_editor_container);
		this.editor.$blockScrolling = Infinity;

		this.editor.setTheme('ace/theme/eclipse');
		this.session = this.editor.getSession();
		this.session.setValue(
			$('#' + options.id)
				.hide()
				.val()
		);

		if (options.type == 'css') {
			this.session.setMode('ace/mode/css');
		} else if (options.type == 'javascript') {
			this.session.setMode('ace/mode/javascript');
		} else {
			this.session.setMode('ace/mode/css');
			this.session.setMode('ace/mode/javascript');
			this.session.setMode('ace/mode/smarty');
		}
		this.session.setUseWrapMode(true);
		this.editor.setOption('maxLines', 10000);
		this.editor.setAutoScrollEditorIntoView(true);
		this.editor.renderer.setShowGutter(false);
		this.editor.setShowPrintMargin(false);
		this.editor.setFontSize(14);
		this.editor.navigateTo(0, 0);
		if (readOnly) {
			this.editor.setReadOnly(true);
			this.editor.setHighlightActiveLine(false);
		}
		this.session.setUseSoftTabs(false);

		if (onChange)
			this.session.on('change', () => {
				onChange(this.editor.getValue());
			});
	}

	componentWillReceiveProps(props) {
		if (this.editor.getValue() != props.value) {
			this.editor.setValue(props.value, -1);
		}
	}

	componentDidMount() {
		if (!this.props.wait) this.init();
	}

	init() {
		$(this.textarea).after(
			`<div class="ace bordered"><div id="ace-textarea-editor-container-${this.lastUniqueId()}"></div></div>`
		);

		this.initEditor({
			prefix: `ace-textarea-editor-${this.lastUniqueId()}-`,
			id: this.lastUniqueId(),
			ace_editor_container: `ace-textarea-editor-container-${this.lastUniqueId()}`,
			type: this.props.type || 'html'
		});
	}

	render() {
		const { className, ...props } = this.props;
		const classes = [];

		if (className) {
			classes.push(className);
		}

		return (
			<div className={classes.join(' ')}>
				<textarea {...props} id={this.lastUniqueId()} ref={input => (this.textarea = input)} />
			</div>
		);
	}
}
